import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { MessageType } from '../shared/model/message-type';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../shared/model/user';
import { Message } from '../shared/model/message';
import * as NoSleep from 'nosleep.js';
import { getServerUrl } from '../shared/utils/utils';
import { SpinnerService } from '../shared/services/spinner.service';
import { GameStatus } from '../shared/model/game-status';
import { WindowsService } from '../shared/services/windows.service';

@Component({
  selector: 'pbg-game-host',
  templateUrl: './game-host.component.html',
  styleUrls: ['./game-host.component.scss']
})
export class GameHostComponent implements OnInit, OnDestroy {
  ioConnection: any;
  user: User = {};
  connectedUsers: User[] = [];
  gamePrefix = 'T';
  gameId = '';
  gameOverMessage = '';
  currentQuestion: any;
  winner: string;
  listeners: any[] = [];
  gameIsOver = false;
  noSleep: any;

  // Dynamic Styling
  avatarWidth = '100%';

  constructor(
    public socketService: SocketService,
    public cookieService: CookieService,
    public router: Router,
    public resolver: ActivatedRoute,
    public renderer: Renderer2,
    public spinnerService: SpinnerService,
    public windowService: WindowsService
  ) {
    try {
      this.noSleep = new NoSleep();
    } catch (e) {
      console.log(e);
    }
    this.spinnerService.hide();
  }

  ngOnInit() {
    try {
      if (document.createEvent('TouchEvent')) {
        this.listeners.push(
          this.renderer.listen(window, 'focus', () => {
            this.sendNotification(MessageType.Host);
          })
        );
      }
    } catch (e) {
      // Not a touch screen.
      console.log(e);
    }

    console.log(this.resolver.snapshot.data.gameExists);
    if (this.resolver.snapshot.data.gameExists.success) {
      this.gameId = this.cookieService.get('gameId');
    }

    this.user.name = 'host';
    this.initModel();
  }

  ngOnDestroy() {
    this.clean();
    this.allowSleep(false);
    this.socketService.close();
  }

  clean() {
    for (let i = 0; i < this.listeners.length; i++) {
      this.listeners[i]();
    }
  }

  initModel(): void {
    this.allowSleep(true);
    this.initIoConnection();
    this.sendNotification(MessageType.Host);
  }

  allowSleep(allow = false) {
    try {
      if (allow) {
        this.noSleep.enable();
      } else {
        this.noSleep.disable();
      }
    } catch (e) {
      console.log(e);
    }
  }

  initIoConnection(): void {
    this.socketService.initSocket(getServerUrl(this.gamePrefix));

    this.ioConnection = this.socketService.onMessage().subscribe((message: any) => {
      console.log(message);
      if (message.action === MessageType.Host) {
        this.hostMessageHandler(message);
      }

      this.responseHandler(message);
    });

    this.socketService.onEvent(MessageType.Connected).subscribe(() => {
      console.log('connected');
    });

    this.socketService.onEvent(MessageType.Disconnected).subscribe(() => {
      console.log('disconnected');
    });
  }

  responseHandler(message: Message) {
    // Needs to be extended, determine what host should show when response is received.
  }

  setGameState(message: Message) {
    // Needs to be extended, determine what host should show when response is received.
  }

  hostMessageHandler(message: Message) {
    // Needs to be extended, determine what host should show when response is received.
    this.connectedUsers = (<any>Object).values(message.content.users);
    this.avatarWidth = `calc(${Math.floor(100 / this.connectedUsers.length)}% - 20px)`;

    if (message.content.status === GameStatus.Waiting) {
      this.gameId = message.content.id;
      this.cookieService.set('gameId', this.gameId, 1, '/');
    }
  }

  goToNewGame() {
    this.router.navigate(['/']);
  }

  sendNotification(action: MessageType): void {
    let message: Message;

    message = {
      from: this.user,
      content: 'host-connected',
      action: action,
      gameId: this.gameId
    };

    this.socketService.send(message);
  }

  playAgain(playAgain = true) {
    this.cookieService.deleteAll('/host');
    this.cookieService.deleteAll('/');
    this.cookieService.deleteAll();

    setTimeout(() => {
      if (playAgain) {
        this.windowService.reload();
      } else {
        this.router.navigate(['']);
      }
    }, 250);
  }
}
